export default __webpack_public_path__ + "static/media/product_attributes.9f3f0e6b.svg";